import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Button } from '@mui/material';
export const MaintenanceDialogFooter = memo(function MaintenanceDialogFooter(props) {
    const { is_new, onDelete, onClose, onClickApply } = props;
    return (_jsxs(Box, { display: "flex", gap: 1, children: [!is_new && (_jsx(Button, { onClick: onDelete, color: "error", children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })), _jsx(Button, { onClick: onClose, color: "primary", children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(Button, { onClick: onClickApply, color: "secondary", children: is_new ? 'Создать' : 'Сохранить' })] }));
});
